export default {
  afterSave (data) {
    if (data.latitude === null) {
      this.show = true
    }

    if (data.latitude) {
      return this.$router.push({name: 'settings.addresses.index'})
    }
  },
  setAddress (address) {
    this.address = {...this.address, ...address}
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/form/resources/methods.js